import { Navigation, Swiper } from 'swiper';
import { addZero, isMobile } from '@/modules/functions';

export class AboutFeatures {
  list;
  slider;
  total;
  current;

  constructor() {}

  init() {
    this.list = document.querySelector('.about-features-list');
    if (!this.list) return;

    this.current = document.querySelector('.about-features-count-current');
    this.total = document.querySelector('.about-features-count-total');

    Swiper.use([Navigation]);

    if (isMobile()) {
      this.createSlider();
    }
  }

  createSlider() {
    this.list.querySelectorAll('.about-features-item').forEach((el) => {
      el.classList.add('swiper-slide');
    });
    this.list.querySelector('.about-features-title').remove();
    const items = this.list.innerHTML;
    this.list.innerHTML = `<div class="swiper about-features-slider"><div class="swiper-wrapper">${items}</div></div>`;

    this.total.innerText = addZero(
      this.list.querySelectorAll('.swiper-slide').length
    );
    this.current.innerText = addZero(1);

    this.slider = new Swiper('.about-features-slider', {
      slidesPerView: 1,
      navigation: {
        prevEl: '.about-features-slider-prev',
        nextEl: '.about-features-slider-next',
      },
      on: {
        slideChange: (swiper) => {
          this.current.innerText = addZero(swiper.activeIndex + 1);
        },
      },
    });
  }
}
